import axios from 'axios';

const getIndicadores = params => axios.get('/indicadores/fornecedores/indicadores', { params });
const getTotalizadores = params => axios.get('/indicadores/fornecedores/indicadores/totalizadores', { params });

export default {
  getIndicadores,
  getTotalizadores,
};
